export async function jsonFetch<T>(url: string, init?: RequestInit): Promise<T> {
  const headers = new Headers(init?.headers)
  headers.set('Content-Type', 'application/json')
  const response = await fetch(url, {
    credentials: 'same-origin',
    ...init,
    headers,
  })
  let body: T & { error?: string }
  try {
    body = (await response.json()) as T & { error?: string }
  } catch {
    const status = response.status >= 500 ? 'Service temporarily unavailable' : 'Invalid server response'
    throw new Error(`${status} (${String(response.status)})`)
  }
  if (!response.ok) throw new Error(body.error ?? `Request failed (${String(response.status)})`)
  return body
}
